import moment from "moment";

export const PRESET_DATE_RANGES = {
	Today: [moment().startOf("day"), moment().endOf("day")],
	"This Week": [moment().startOf("week"), moment().endOf("week")],
	"This Month": [moment().startOf("month"), moment().endOf("month")],
	"Last Month": [moment().startOf("month").subtract(1, "month"), moment().endOf("month").subtract(1, "month")],
	"This Year": [moment().startOf("year"), moment().endOf("year")],
	"Last 7 Days": [moment().startOf("days").subtract(7, "days"), moment().endOf("days")],
	"Last 30 Days": [moment().startOf("days").subtract(30, "days"), moment().endOf("days")],
	"Next 7 Days": [moment().startOf("days"), moment().endOf("days").add(7, "day")],
	"Next 30 Days": [moment().startOf("days"), moment().endOf("days").add(30, "day")],
} as any;
